import DashboardHome from '@/components/Dashboard/Home'
import Products from '@/components/Equipment/Index'
import NewEquipment from '@/components/Equipment/NewEquipment'
import Equipment from '@/components/Equipment/Equipment'
import EquipmentRequests from '@/components/EquipmentRequests/Home'

export default [
  {
    path: '/',
    name: 'Dashboard',
    component: DashboardHome,
    children: []
  },
  {
    path: '/equipment-requests',
    name: 'Equipment Requests',
    component: EquipmentRequests
  },
  {
    path: '/equipment',
    name: 'Equipment',
    component: Products,
    children: [{
      path: '',
      name: 'Equipment',
      component: Equipment
    },
    //  {
    //   path: 'new',
    //   name: 'Add New Equipment',
    //   component: NewEquipment
    // }
  ]
  }
]



// WEBPACK FOOTER //
// ./src/router/provincial-manager.js